<h2 mat-dialog-title class="dialog-title">
    <mat-icon class="title-icon">group_add</mat-icon>
    <span>{{ $any(data.node.data)?.partType === 'post' ? 'Assign Staff to Post' : 'Assign Staff to Posts' }}</span>
    <span class="subtitle">{{ data.node.data?.name }}</span>
    <span class="spacer"></span>
    <button mat-icon-button mat-dialog-close class="close-button">
        <mat-icon>close</mat-icon>
    </button>
</h2>

<mat-dialog-content class="dialog-content">
    <!-- Empty state -->
    <div *ngIf="rows.length === 0" class="empty-state">
        <mat-icon class="empty-icon">info</mat-icon>
        <p>No posts available for staff assignment here.</p>
    </div>

    <div *ngIf="rows.length > 0" class="content-layout">
        <!-- Left: Tree panel -->
        <div class="tree-panel">
            <div class="summary-bar">
                <mat-icon class="summary-icon">account_tree</mat-icon>
                <span>{{ postCount }} post(s) in structure</span>
            </div>

            <!-- Tree filter search -->
            <div class="tree-filter">
                <mat-form-field appearance="outline" class="tree-filter-field" subscriptSizing="dynamic">
                    <mat-label>Filter tree</mat-label>
                    <input
                        matInput
                        [(ngModel)]="treeFilterTerm"
                        (ngModelChange)="onTreeFilterChange()"
                        placeholder="Search sections, units, posts..."
                    />
                    <mat-icon *ngIf="!treeFilterTerm" matSuffix>search</mat-icon>
                    <button *ngIf="treeFilterTerm" matSuffix mat-icon-button (click)="clearTreeFilter()">
                        <mat-icon>clear</mat-icon>
                    </button>
                </mat-form-field>
            </div>

            <div class="tree-container">
                <ng-container *ngFor="let row of rows">
                    <div
                        *ngIf="isRowVisible(row)"
                        class="tree-row"
                        [class.post-row]="row.isPost"
                        [class.header-row]="!row.isPost"
                        [style.padding-left.px]="16 + row.indent * 28"
                    >
                        <!-- Section/Unit header rows -->
                        <div *ngIf="!row.isPost" class="row-header" (click)="toggleCollapse(row)">
                            <mat-icon class="collapse-icon" [class.collapsed]="row.isCollapsed">
                                {{ row.hasChildren ? 'expand_more' : '' }}
                            </mat-icon>
                            <mat-icon class="row-icon">{{ getPartTypeIcon(row.partType) }}</mat-icon>
                            <span class="row-name">{{ row.name }}</span>
                            <span class="row-type-badge">{{ row.partType }}</span>
                        </div>

                        <!-- Post rows with assignment controls -->
                        <div *ngIf="row.isPost" class="post-card">
                            <div class="post-header">
                                <mat-icon class="row-icon post-icon" [style.color]="colorsService.getColor('positions')"
                                    >person_pin</mat-icon
                                >
                                <span class="row-name">{{ row.name }}</span>
                                <mat-icon
                                    *ngIf="row.noHats"
                                    class="warning-icon"
                                    matTooltip="No hats on this post — users cannot be assigned"
                                >
                                    warning
                                </mat-icon>
                            </div>

                            <!-- Current users -->
                            <div class="users-section" *ngIf="row.currentUsers.length > 0">
                                <div
                                    *ngFor="let user of row.currentUsers"
                                    class="user-item-block"
                                    [class.being-modified]="isUserBeingModified(row, user)"
                                >
                                    <div
                                        class="user-item"
                                        [class.removing]="isUserBeingRemoved(row, user)"
                                        [class.approving]="isUserBeingApproved(row, user)"
                                        [class.rejecting]="isUserBeingRejected(row, user)"
                                        [class.pending-user]="user.isPending"
                                    >
                                        <!-- User avatar or icon -->
                                        <div *ngIf="user.isPending" class="pending-avatar-wrap">
                                            <img
                                                *ngIf="user.photoThumbnail"
                                                [src]="user.photoThumbnail"
                                                class="user-avatar pending-avatar"
                                                alt=""
                                            />
                                            <div
                                                *ngIf="!user.photoThumbnail && user.profileColor"
                                                class="user-avatar-placeholder pending-avatar"
                                                [style.background-color]="user.profileColor"
                                            >
                                                {{ user.name.charAt(0).toUpperCase() }}
                                            </div>
                                            <mat-icon
                                                *ngIf="!user.photoThumbnail && !user.profileColor"
                                                class="user-icon"
                                                >person</mat-icon
                                            >
                                        </div>
                                        <ng-container *ngIf="!user.isPending">
                                            <img
                                                *ngIf="user.photoThumbnail"
                                                [src]="user.photoThumbnail"
                                                class="user-avatar"
                                                alt=""
                                            />
                                            <div
                                                *ngIf="!user.photoThumbnail && user.profileColor"
                                                class="user-avatar-placeholder"
                                                [style.background-color]="user.profileColor"
                                            >
                                                {{ user.name.charAt(0).toUpperCase() }}
                                            </div>
                                            <mat-icon
                                                *ngIf="!user.photoThumbnail && !user.profileColor"
                                                class="user-icon"
                                                >person</mat-icon
                                            >
                                        </ng-container>

                                        <span class="user-name" [class.strikethrough]="isUserBeingRemoved(row, user)">
                                            {{ user.name }}
                                        </span>

                                        <!-- Hat chips (before pending badge) -->
                                        <span *ngIf="user.hatNames?.length" class="user-hat-chips">
                                            <span
                                                *ngFor="let hatName of user.hatNames"
                                                class="user-hat-chip"
                                                [class.pending-hat]="user.isPending"
                                                [style.background]="colorsService.getBackground('hats', 0.15)"
                                                [style.color]="colorsService.getColor('hats')"
                                                [style.border-color]="
                                                    user.isPending ? '#e65100' : colorsService.getColor('hats')
                                                "
                                                [matTooltip]="
                                                    user.isPending ? hatName + ' (pending approval)' : hatName
                                                "
                                            >
                                                <mat-icon class="hat-chip-icon">school</mat-icon>
                                                {{ hatName }}
                                                <mat-icon *ngIf="user.isPending" class="hat-chip-icon pending-hourglass"
                                                    >hourglass_top</mat-icon
                                                >
                                            </span>
                                        </span>

                                        <!-- "+N hats queued" badge when this user has a pending modification -->
                                        <span
                                            *ngIf="isUserBeingModified(row, user)"
                                            class="modify-badge"
                                            [matTooltip]="'Queued to add: ' + getModifyHatSummary(row, user)"
                                        >
                                            <mat-icon class="modify-badge-icon">add_moderator</mat-icon>
                                            +{{ user.hatKeysToAdd?.length }} hat{{
                                                (user.hatKeysToAdd?.length || 0) === 1 ? '' : 's'
                                            }}
                                        </span>

                                        <!-- Pending badge -->
                                        <span
                                            *ngIf="user.isPending"
                                            class="pending-badge"
                                            [class.pending-badge--acceptance]="user.awaitingAcceptance"
                                            [matTooltip]="
                                                user.awaitingAcceptance
                                                    ? 'Invitation sent — waiting for the user to accept before approval is available.'
                                                    : 'This user is awaiting approval for assignment to this post'
                                            "
                                        >
                                            {{ user.awaitingAcceptance ? 'Pending Acceptance' : 'Pending' }}
                                        </span>

                                        <!-- Action buttons -->
                                        <div class="user-actions">
                                            <!-- Add more hats — available for BOTH active and pending
                                         users. For a pending user, new hats are merged into
                                         their existing approval record so the approver sees
                                         the full set at once (no duplicate approval created). -->
                                            <button
                                                *ngIf="
                                                    !isUserBeingRemoved(row, user) &&
                                                    !isUserBeingRejected(row, user) &&
                                                    hasHatsAvailableToAdd(row, user)
                                                "
                                                mat-icon-button
                                                class="user-action-btn add-hats-btn"
                                                [class.active]="user.showHatPicker"
                                                [matTooltip]="
                                                    user.showHatPicker
                                                        ? 'Close hat picker'
                                                        : user.isPending
                                                          ? 'Add more hats to this pending request'
                                                          : 'Add more hats to this user'
                                                "
                                                (click)="onToggleAddHats(row, user)"
                                            >
                                                <mat-icon>{{
                                                    user.showHatPicker ? 'expand_less' : 'add_moderator'
                                                }}</mat-icon>
                                            </button>

                                            <!-- Pending user: approve / reject toggles -->
                                            <ng-container *ngIf="user.isPending">
                                                <!-- Approve toggle -->
                                                <button
                                                    *ngIf="
                                                        !isUserBeingApproved(row, user) &&
                                                        !isUserBeingRejected(row, user)
                                                    "
                                                    mat-icon-button
                                                    class="user-action-btn approve-btn"
                                                    [disabled]="user.awaitingAcceptance"
                                                    [matTooltip]="
                                                        user.awaitingAcceptance
                                                            ? 'User has not yet accepted the invitation. Approval becomes available once they accept.'
                                                            : 'Queue approval'
                                                    "
                                                    (click)="onApproveUser(row, user)"
                                                >
                                                    <mat-icon>check_circle</mat-icon>
                                                </button>
                                                <!-- Undo approve -->
                                                <button
                                                    *ngIf="isUserBeingApproved(row, user)"
                                                    mat-icon-button
                                                    class="user-action-btn undo-approve-btn"
                                                    matTooltip="Undo approval"
                                                    (click)="onUndoApproveUser(row, user)"
                                                >
                                                    <mat-icon>undo</mat-icon>
                                                </button>
                                                <!-- Reject toggle -->
                                                <button
                                                    *ngIf="
                                                        !isUserBeingRejected(row, user) &&
                                                        !isUserBeingApproved(row, user)
                                                    "
                                                    mat-icon-button
                                                    class="user-action-btn reject-btn"
                                                    color="warn"
                                                    [matTooltip]="user.approvalId ? 'Queue rejection' : 'Queue removal'"
                                                    (click)="onRejectUser(row, user)"
                                                >
                                                    <mat-icon>{{
                                                        user.approvalId ? 'cancel' : 'remove_circle_outline'
                                                    }}</mat-icon>
                                                </button>
                                                <!-- Undo reject -->
                                                <button
                                                    *ngIf="isUserBeingRejected(row, user)"
                                                    mat-icon-button
                                                    class="user-action-btn"
                                                    color="primary"
                                                    matTooltip="Undo rejection"
                                                    (click)="onUndoRejectUser(row, user)"
                                                >
                                                    <mat-icon>undo</mat-icon>
                                                </button>
                                            </ng-container>

                                            <!-- Active user: remove / undo -->
                                            <ng-container *ngIf="!user.isPending">
                                                <button
                                                    *ngIf="!isUserBeingRemoved(row, user)"
                                                    mat-icon-button
                                                    class="user-action-btn"
                                                    color="warn"
                                                    matTooltip="Remove user from post"
                                                    (click)="onRemoveCurrentUser(row, user)"
                                                >
                                                    <mat-icon>remove_circle_outline</mat-icon>
                                                </button>
                                                <button
                                                    *ngIf="isUserBeingRemoved(row, user)"
                                                    mat-icon-button
                                                    class="user-action-btn"
                                                    color="primary"
                                                    matTooltip="Undo removal"
                                                    (click)="onUndoRemoveUser(row, user)"
                                                >
                                                    <mat-icon>undo</mat-icon>
                                                </button>
                                            </ng-container>
                                        </div>
                                    </div>

                                    <!-- Inline hat picker (modify flow) — shown for both active and
                                 pending users. For a pending user, the hint explains merge
                                 into existing approval; for an active user with approvals
                                 ON, it warns new hats will require approval. -->
                                    <div
                                        *ngIf="
                                            user.showHatPicker &&
                                            !isUserBeingRemoved(row, user) &&
                                            !isUserBeingRejected(row, user)
                                        "
                                        class="hat-selection modify-hat-picker"
                                        [class.pending-picker]="user.isPending"
                                    >
                                        <mat-form-field
                                            appearance="outline"
                                            class="hat-select-field"
                                            subscriptSizing="dynamic"
                                        >
                                            <mat-label>Add hats to {{ user.name }}</mat-label>
                                            <mat-select
                                                multiple
                                                [value]="user.hatKeysToAdd || []"
                                                (selectionChange)="onModifyHatSelectionChange(row, user, $event.value)"
                                            >
                                                <mat-optgroup
                                                    *ngIf="getAvailablePositionHatsForUser(row, user).length > 0"
                                                    label="Position Hats on this Post"
                                                >
                                                    <mat-option
                                                        *ngFor="let hat of getAvailablePositionHatsForUser(row, user)"
                                                        [value]="hat.key"
                                                    >
                                                        {{ hat.name }}
                                                    </mat-option>
                                                </mat-optgroup>
                                                <mat-optgroup
                                                    *ngIf="getAvailableSpecialRightsHatsForUser(row, user).length > 0"
                                                    label="Special Rights Hats"
                                                >
                                                    <mat-option
                                                        *ngFor="
                                                            let hat of getAvailableSpecialRightsHatsForUser(row, user)
                                                        "
                                                        [value]="hat.key"
                                                    >
                                                        {{ hat.name }}
                                                    </mat-option>
                                                </mat-optgroup>
                                            </mat-select>
                                        </mat-form-field>
                                        <div class="modify-picker-footer">
                                            <span *ngIf="user.isPending" class="approval-hint pending-merge">
                                                <mat-icon>merge_type</mat-icon>
                                                New hats will be merged into this user's pending approval
                                            </span>
                                            <span *ngIf="!user.isPending && requireApproval" class="approval-hint">
                                                <mat-icon>schedule</mat-icon>
                                                New hats will require approval
                                            </span>
                                            <button
                                                mat-button
                                                class="modify-cancel-btn"
                                                (click)="onCancelModify(row, user)"
                                            >
                                                <mat-icon>close</mat-icon>
                                                Cancel
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- Users to add (pending) -->
                            <div class="users-section adding" *ngIf="row.usersToAdd.length > 0">
                                <div *ngFor="let user of row.usersToAdd" class="user-item-block new-user">
                                    <div class="user-item">
                                        <mat-icon class="user-icon add-icon">person_add</mat-icon>
                                        <span class="user-name">{{ user.name }}</span>
                                        <span *ngIf="requireApproval" class="pending-badge">pending approval</span>
                                        <button
                                            mat-icon-button
                                            class="user-action-btn"
                                            color="warn"
                                            matTooltip="Cancel assignment"
                                            (click)="onRemoveNewUser(row, user)"
                                        >
                                            <mat-icon>close</mat-icon>
                                        </button>
                                    </div>
                                    <!-- Hat selection dropdown -->
                                    <div class="hat-selection">
                                        <mat-form-field
                                            appearance="outline"
                                            class="hat-select-field"
                                            subscriptSizing="dynamic"
                                        >
                                            <mat-label>Select hats</mat-label>
                                            <mat-select
                                                multiple
                                                [value]="user.selectedHatKeys"
                                                (selectionChange)="onHatSelectionChange(row, user, $event.value)"
                                            >
                                                <mat-optgroup *ngIf="row.hats.length > 0" label="Position Hats">
                                                    <mat-option *ngFor="let hat of row.hats" [value]="hat.key">
                                                        {{ hat.name }}
                                                    </mat-option>
                                                </mat-optgroup>
                                                <mat-optgroup
                                                    *ngIf="row.specialRightsHats.length > 0"
                                                    label="Special Rights Hats"
                                                >
                                                    <mat-option
                                                        *ngFor="let hat of row.specialRightsHats"
                                                        [value]="hat.key"
                                                    >
                                                        {{ hat.name }}
                                                    </mat-option>
                                                </mat-optgroup>
                                            </mat-select>
                                        </mat-form-field>
                                        <div *ngIf="!hasPositionHatSelected(row, user)" class="hat-warning">
                                            <mat-icon>warning</mat-icon>
                                            <span>At least one position hat required</span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- Linked post: it represents another post — people are assigned THERE, so
                                 no "Search & add user" here (anyone already on it stays listed above). -->
                            <div *ngIf="row.linkedTo as link" class="linked-note">
                                <mat-icon class="linked-note-icon">link</mat-icon>
                                <div class="linked-note-text">
                                    <div class="linked-note-title">
                                        Represents {{ link.name }} — {{ link.summary }}.
                                    </div>
                                    <div class="linked-note-hint">Assign people on {{ link.name }}.</div>
                                </div>
                                <button
                                    mat-stroked-button
                                    color="primary"
                                    class="linked-note-go"
                                    (click)="goToOrigin(row)"
                                >
                                    Go to origin
                                </button>
                            </div>

                            <!-- No users message -->
                            <div
                                *ngIf="!row.linkedTo && row.currentUsers.length === 0 && row.usersToAdd.length === 0"
                                class="no-users"
                            >
                                <span>No staff assigned</span>
                            </div>

                            <!-- Search / Add user dropdown -->
                            <div class="add-user-field" *ngIf="!row.noHats && !row.linkedTo">
                                <mat-form-field appearance="outline" class="search-field">
                                    <mat-label>Search &amp; add user</mat-label>
                                    <input
                                        matInput
                                        #userSearchInput
                                        [(ngModel)]="row.searchText"
                                        (ngModelChange)="onSearchChange(row)"
                                        (focus)="onSearchFocus(row)"
                                        [matAutocomplete]="auto"
                                        placeholder="Select or search for a user..."
                                    />
                                    <mat-icon matSuffix>arrow_drop_down</mat-icon>
                                    <mat-autocomplete
                                        #auto="matAutocomplete"
                                        (optionSelected)="onUserSelected(row, $event, userSearchInput)"
                                        [displayWith]="displayUserName"
                                        autoActiveFirstOption
                                    >
                                        <mat-option *ngFor="let user of row.filteredUsers" [value]="user.key">
                                            <mat-icon>person</mat-icon>
                                            <span>{{ user.name }}</span>
                                            <span *ngIf="user.email" class="option-email"> — {{ user.email }}</span>
                                        </mat-option>
                                        <mat-option *ngIf="row.searchText && row.filteredUsers.length === 0" disabled>
                                            No matching users found
                                        </mat-option>
                                    </mat-autocomplete>
                                </mat-form-field>
                            </div>
                        </div>
                    </div>
                </ng-container>
            </div>
        </div>

        <!-- Right: Changes sidebar -->
        <div class="changes-panel">
            <div class="changes-panel-header">
                <mat-icon>list_alt</mat-icon>
                <span>{{
                    savePhase === 'processing' || savePhase === 'done' ? 'Task Progress' : 'Pending Changes'
                }}</span>
                <span *ngIf="requireApproval && savePhase === 'idle'" class="approval-badge">Approval required</span>
            </div>
            <div class="changes-panel-body">
                <!-- Idle: show pending changes -->
                <ng-container *ngIf="savePhase === 'idle'">
                    <div *ngIf="!hasChanges" class="no-changes">
                        <mat-icon>check_circle_outline</mat-icon>
                        <span>No changes yet</span>
                        <p>Search and add users to posts, or remove existing assignments.</p>
                    </div>
                    <div *ngIf="hasChanges">
                        <div
                            *ngFor="let change of changesSummary"
                            class="change-item"
                            [class.add]="change.action === 'add'"
                            [class.remove]="change.action === 'remove'"
                            [class.approve]="change.action === 'approve'"
                            [class.reject]="change.action === 'reject'"
                            [class.modify]="change.action === 'modify'"
                        >
                            <mat-icon *ngIf="change.action === 'add' && !change.pending" class="change-icon add"
                                >add_circle</mat-icon
                            >
                            <mat-icon *ngIf="change.action === 'add' && change.pending" class="change-icon pending"
                                >schedule</mat-icon
                            >
                            <mat-icon *ngIf="change.action === 'remove'" class="change-icon remove"
                                >remove_circle</mat-icon
                            >
                            <mat-icon *ngIf="change.action === 'approve'" class="change-icon approve"
                                >check_circle</mat-icon
                            >
                            <mat-icon *ngIf="change.action === 'reject'" class="change-icon reject">cancel</mat-icon>
                            <mat-icon *ngIf="change.action === 'modify' && !change.pending" class="change-icon modify"
                                >add_moderator</mat-icon
                            >
                            <mat-icon *ngIf="change.action === 'modify' && change.pending" class="change-icon pending"
                                >schedule</mat-icon
                            >
                            <span>
                                <strong>{{ change.userName }}</strong>
                                <span *ngIf="change.action === 'add' && !change.pending"> → </span>
                                <span *ngIf="change.action === 'add' && change.pending"> ⏳ </span>
                                <span *ngIf="change.action === 'remove'"> ✕ </span>
                                <span *ngIf="change.action === 'approve'"> ✓ </span>
                                <span *ngIf="change.action === 'reject'"> ✕ </span>
                                <span *ngIf="change.action === 'modify' && !change.pending"> + </span>
                                <span *ngIf="change.action === 'modify' && change.pending"> ⏳+ </span>
                                {{ change.postName }}
                                <span *ngIf="change.hatNames" class="change-hats">
                                    <br />
                                    <mat-icon class="hat-icon-small">military_tech</mat-icon>
                                    {{ change.hatNames }}
                                </span>
                            </span>
                        </div>
                    </div>
                </ng-container>

                <!-- Processing / Done: show task statuses -->
                <ng-container *ngIf="savePhase === 'processing' || savePhase === 'done'">
                    <!-- Assignment results summary -->
                    <div *ngFor="let sr of saveResults" class="change-item" [ngClass]="sr.iconClass">
                        <mat-icon class="change-icon" [ngClass]="sr.iconClass">{{ sr.icon }}</mat-icon>
                        <span class="task-info">
                            <strong>{{ sr.userName }}</strong>
                            <span class="task-action">{{ sr.postName }} &mdash; {{ sr.outcome }}</span>
                        </span>
                    </div>

                    <!-- Backend task statuses (when there are backend tasks) -->
                    <div *ngIf="taskStatuses.length > 0" class="backend-tasks-divider">
                        <small>Backend processing</small>
                    </div>
                    <div *ngFor="let ts of taskStatuses" class="change-item" [ngClass]="ts.action">
                        <mat-icon class="change-icon" [ngClass]="ts.action">{{ ts.icon }}</mat-icon>
                        <span class="task-info">
                            <strong>{{ ts.name }}</strong>
                            <span class="task-action">{{ ts.action }}</span>
                        </span>
                        <mat-icon
                            class="status-icon"
                            [class.completed]="ts.status === 'completed'"
                            [class.processing]="ts.status === 'processing'"
                            [class.error]="ts.status === 'failed'"
                        >
                            {{ ts.statusIcon }}
                        </mat-icon>
                    </div>
                    <div *ngIf="taskStatuses.length === 0 && savePhase === 'processing'" class="no-changes">
                        <mat-icon>hourglass_empty</mat-icon>
                        <span>Waiting for backend tasks...</span>
                    </div>
                </ng-container>
            </div>

            <!-- Save progress -->
            <div *ngIf="savePhase === 'writing'" class="save-progress">
                <mat-progress-bar mode="determinate" [value]="(saveProgress / totalChanges) * 100"></mat-progress-bar>
                <span>Writing changes... {{ saveProgress }} / {{ totalChanges }}</span>
            </div>
            <div *ngIf="savePhase === 'processing'" class="save-progress">
                <mat-progress-bar
                    mode="determinate"
                    [value]="totalTasks > 0 ? (tasksCompleted / totalTasks) * 100 : 0"
                ></mat-progress-bar>
                <span>Processing tasks... {{ tasksCompleted }} / {{ totalTasks }}</span>
            </div>
            <div *ngIf="savePhase === 'done'" class="save-progress done">
                <mat-icon>check_circle</mat-icon>
                <span>All tasks completed!</span>
            </div>
            <div *ngIf="savePhase === 'error'" class="save-progress error">
                <mat-icon>error</mat-icon>
                <span>Save failed. Check console for details.</span>
            </div>
        </div>
    </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <ng-container *ngIf="savePhase === 'done'; else normalActions">
        <button mat-button (click)="continueEditing()">
            <mat-icon>edit</mat-icon>
            Continue Editing
        </button>
        <button mat-raised-button color="primary" (click)="dialogRef.close({ applied: true })">
            <mat-icon>check</mat-icon>
            Close
        </button>
    </ng-container>
    <ng-template #normalActions>
        <button mat-button mat-dialog-close [disabled]="isSaving">Cancel</button>
        <button
            mat-raised-button
            color="primary"
            [disabled]="!hasChanges || !allHatsValid || isSaving"
            (click)="onSave()"
        >
            <mat-icon>save</mat-icon>
            Apply Changes ({{ changesSummary.length }})
        </button>
    </ng-template>
</mat-dialog-actions>
